import React from "react";
import {Button, Drawer, Form, Input, Select, Spin} from "antd";
import {UnitDropdown} from "../controller/Global";
import {WasteStreamCodeList, WasteStreamCodePost} from "../models/waste_stream_code";
import {ContainerTypeFilter} from "./ContainerType";
import {Role, UserContext} from "../controller/Utils";

const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;

class WasteStreamFilterForm extends React.Component {
  static contextType = UserContext;
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  fetchWasterStreamCode = (value = '') => {
    this.setState({fetching: true});
    const requestData = { 'search': value, 'service_type': this.props.service_type };
    WasteStreamCodeList(requestData)
      .then(body => {
        const data = [];
        body.data.results.forEach(function (stream) {
          const name = stream.container? stream.container.name: '';
          data.push({text:stream.code + ' - ' + stream.description + ' - ' + stream.unit + ' - '+ name, value: stream.id})
        });
        this.setState({ data, fetching: false });
      });
  };
  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
    this.props.onChange(value.key);
  };
  resetValue = () => {
    this.props.form.resetFields();
    this.setState({
      value: {key: '', label: ''},
      fetching: false
    });
  }
  handleDrawerSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        WasteStreamCodePost(values)
          .then(response => {
            this.setState({
              visible: false,
              value: {key: response.id, label: response.code}
            });
            this.props.onChange(response.id);
          });
      }
    });
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)

  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {fetching, data, value, fields} = this.state;
    const {getFieldDecorator} = this.props.form;
    return (
      <div className="pos-relative">
        <Select labelInValue showSearch value={value} placeholder="Select Waste Stream Code" dropdownClassName="drawer-select" notFoundContent={fetching ? <Spin size="small" /> : "Not Found"} filterOption={false} onFocus={this.fetchWasterStreamCode} onSearch={this.fetchWasterStreamCode} onChange={this.handleChange} style={{ width: "100%" }}>
          {data.map(d => (<Option key={d.value}>{d.text}</Option>))}
        </Select>
        <Role allow={["admin"]} user={this.context.user}>
        <Button className="plus-btn-pop" type="primary" htmlType='button' onClick={this.showDrawer}>
          <i className="fa fa-plus" />
        </Button>
        </Role>
        <div>
          <Drawer title="Add Waste Stream Code" placement="right" onClose={this.onClose} width={"25%"} visible={this.state.visible} className="floating-form inner-drawer" destroyOnClose={true}>
            <Form>
              <FormItem label="Code">
                {getFieldDecorator('code', {
                  rules: [{required: true, message: 'Please input waste stream code'}],
                })(<Input placeholder="Enter waste stream code" />)}
              </FormItem>
              <FormItem label="Unit">
                {getFieldDecorator('unit', {
                  rules: [{required: true, message: 'Please select unit'}],
                })(<Select className="unit-ws" placeholder="Select Unit" {...fields}>
                  {UnitDropdown()}
                </Select>)}
              </FormItem>
              <FormItem label="Descripton">
                {getFieldDecorator('description', {
                  rules: [{required: true, message: 'Please input waste stream description'}],
                })(<TextArea placeholder="Enter waste stream description" />)}
              </FormItem>
              <FormItem label="Container Type">
                  {getFieldDecorator('container', {
                    rules: [{ required: true, message: 'Please select container type' }],
                  })(<ContainerTypeFilter onRef={ref => (this.container = ref)} {...fields} />)}
                </FormItem>
              <Button type="primary" onClick={this.handleDrawerSubmit} htmlType="button">Add Waste Stream Code</Button>
            </Form>
          </Drawer>
        </div>
      </div>
    );
  }
}

export const WasteStreamFilter = Form.create()(WasteStreamFilterForm);


// WEBPACK FOOTER //
// ./src/filters/WasteStreamCode.jsx